
// BaseUrl for Main page
export  const BASE_URL = 'https://api.taab30.com/';
export  const SHOP_URL = 'https://api.taab30.com/shop';

// BaseUrl for Admin panel
export const PANEL_URL =  'api.nanopardazan.com/taab30admin.aspx'